module.exports = "img/photo21.b92f0f.jpg";